export default {
  existe(usuario) {
    let existe = $cookies.isKey(usuario);
    if (existe) return true;
    return false;
  },
  getCookie(nomeCookie) {
    if ($cookies.isKey(nomeCookie)) {
      return $cookies.get(nomeCookie);
    } else {
      return "";
    }
  }
};
